// extracted by mini-css-extract-plugin
module.exports = {"icon":"QGWAOKbiCHnjTE4k4V7d","root":"iM0eVtrP74mm0F6zLVXj"};